/*
 * A&K 10.000
 * Author: Rouven Pajewski
 * Company: ActiView GmbH
 *
 * http://www.actiview.de
 */

$(document).ready(function() {
    var $window = $(window),
        services = [];

    $('.service-checkbox').change(function() {
        var price = parseFloat($('.info-price').attr('data-info-price').replace(',','.')),
            originalPrice = parseFloat($('.info-price').attr('data-orig-price').replace(',','.')),
            additional = parseFloat($(this).data('service-price').replace(',','.')),
            currentId = $(this).attr('id'),
            inArray = false;
 
        if ($(this).is(':checked')) {
            $(this).closest('.service-checkbox-border').addClass('active');
            price += additional;

            for (var i = 0; i < services.length; i++) {
                if (services[i]['BasketItemItemID'] === currentId) {
                    inArray = true;
                    break;
                }
            }

            if (!inArray) {
                services.push({
                    BasketItemItemID: currentId,
                    BasketItemPriceID: 1,
                    BasketItemQuantity: 1
                });
            }
        } else {
            $(this).closest('.service-checkbox-border').removeClass('active');

            if ((price - additional) >= originalPrice) {
                price -= additional;
            }

            for (var i = 0; i < services.length; i++) {
                if (services[i]['BasketItemItemID'] === currentId) {
                    services.splice(i, 0);
                    break;
                }
            }
        }

        $('.info-price').attr('data-info-price', price);
        $('.info-price').html(price.toFixed(2).replace('.',',') + '€');
    });

    $('[data-add-services="toBasket"]').click(function() {
        // Fügt die Zusatzprodukte zum Checkout hinzu
        $.ajax('/rest/checkout/basketitemslist/', {
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(services),
            error: function () {
                services = [];
            }
        });
    });
});